import React, { useState } from "react";
import { func, object } from "prop-types";

import "./login-modal.m.css";

const currencyLabels = {
  EUR: "€",
};

export const LoginModal = ({ setActiveTab, AccountModal, selectedPlan, selectedSubscriptionGroup=null }) => {
  const [showAccountModal, setShowAccountModal] = useState(true);
  const { plan } = selectedPlan;
  return (
    <div styleName="checkout-wrapper">
      <div styleName="pricing-card">
        <div styleName="pricing-header"><h2>KÄYTTÄJÄTUNNUS</h2><h3>Aloita tästä!</h3></div>
        <div>
          {showAccountModal && (
            <AccountModal
              defaultActiveTab="register"
              isPopup={false}
              customCallbackUrl={global.location.href}
              onClose={() => {
                setShowAccountModal(false);
                setActiveTab("checkout");
              }}
            />
          )}
        </div>
        <div styleName="plan-preview">
          <div styleName="label">Tilauksen tiedot:</div>
          <div styleName="plan-details">
            <div styleName="plan-name-and-price">
              <div styleName="group-plan-name">
                {selectedSubscriptionGroup
                  ? `${selectedSubscriptionGroup.charAt(0).toUpperCase()}${selectedSubscriptionGroup.slice(1).toLowerCase()}, `
                  : ''}
                {plan.title}
              </div>
              {/*<div styleName="price">{`${currencyLabels[plan.price_currency]} ${plan.price_cents / 100}`}</div>*/}
            </div>
          </div>
          {/*<div styleName="validity">{`Valid for ${plan.duration_length} ${
            plan.duration_length === 1
              ? plan.duration_unit.substring(0, plan.duration_unit.length - 1)
              : plan.duration_unit
          }`}</div>*/}
        </div>
        <div styleName="bottom-red-border"></div>
      </div>
    </div>
  );
};

LoginModal.propTypes = {
  setActiveTab: func,
  AccountModal: func,
  selectedPlan: object,
};
